/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Streak_FreezeInputs */

const en_us2_today_streak_freeze = /** @type {(inputs: Today_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One missed week will not break the streak`)
};

const pt_br2_today_streak_freeze = /** @type {(inputs: Today_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma semana perdida não quebra a sequência`)
};

const es_419_today_streak_freeze = /** @type {(inputs: Today_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una semana perdida no rompe la racha`)
};

const pt_pt2_today_streak_freeze = /** @type {(inputs: Today_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma semana falhada não quebra a sequência`)
};

const fr_fr2_today_streak_freeze = /** @type {(inputs: Today_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une semaine manquée ne brise pas la série`)
};

const de_de2_today_streak_freeze = /** @type {(inputs: Today_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine verpasste Woche beendet die Serie nicht`)
};

const it_it2_today_streak_freeze = /** @type {(inputs: Today_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una settimana saltata non interrompe la serie`)
};

/**
* | output |
* | --- |
* | "One missed week will not break the streak" |
*
* @param {Today_Streak_FreezeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_streak_freeze = /** @type {((inputs?: Today_Streak_FreezeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Streak_FreezeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_streak_freeze(inputs)
	if (locale === "es-419") return es_419_today_streak_freeze(inputs)
	if (locale === "pt-PT") return pt_pt2_today_streak_freeze(inputs)
	if (locale === "fr-FR") return fr_fr2_today_streak_freeze(inputs)
	if (locale === "de-DE") return de_de2_today_streak_freeze(inputs)
	if (locale === "it-IT") return it_it2_today_streak_freeze(inputs)
	return en_us2_today_streak_freeze(inputs)
});
export { today_streak_freeze as "today.streak_freeze" }